
import ProductList from "../components/ProductList";
import FilterSection from "../components/FilterSection";


// const API = "http://ec2-34-197-250-249.compute-1.amazonaws.com/api/product_read";

const Products = () => {

    return (
        <>
            <div className='page-banner hero-container'>
                <div className='banner-content'>
                    <h1>All Products</h1>
                </div>
            </div>

            <section className="light-section">
                <div className="container">
                    <div className="row">
                        <div className="w-30">
                            <FilterSection />
                        </div>
                        <div className="w-70">
                            <ProductList />
                        </div>
                    </div>
                </div >
            </section >
        </>
    );
};

export default Products;